import { BlockMessage, IntegrationMessage, integrationMessageToBlockMessage } from '@botpress/webchat'
import { getApiClient } from '../../stores'
import { HITLIntegrationNotEnabledError } from './errors'
import { HistoricMessage } from './types'
import { nanoid } from 'nanoid'

export async function getHITLWebhookId({
  botId,
  workspaceId,
}: {
  botId: string
  workspaceId: string
}): Promise<string> {
  const bpClient = getApiClient({ workspaceId, botId })
  const { bot } = await bpClient.getBot({ id: botId })

  const integrationsByName = Object.entries(bot.integrations).map(([intId, int]) => ({ ...int, id: intId }))
  const hitlIntegration = integrationsByName.find((int) => int.name === 'hitl')

  if (!hitlIntegration || !hitlIntegration.enabled) {
    throw new HITLIntegrationNotEnabledError()
  }

  const { webhookId } = hitlIntegration
  return webhookId
}

export const historicMessageToBlockMessage = (
  message: HistoricMessage,
  conversationId: string,
  assignedAt: string
): BlockMessage => {
  const integrationMessage: IntegrationMessage = {
    id: nanoid(),
    createdAt: new Date(new Date(assignedAt).getTime() - 60000).getTime().toString(),
    payload: {
      ...message.payload,
      type: message.type,
    } as IntegrationMessage['payload'],
    userId: message.source.type == 'user' ? message.source.userId : '',
    conversationId,
    metadata: {
      historic: true,
    },
  }

  return integrationMessageToBlockMessage(integrationMessage)
}
